import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { Modal } from "react-bootstrap";
import closeBtn from "../../include/media/close.svg";
import { connect } from "react-redux";
import { Callbacks } from "jquery";
import { getAppointment, loadFeedback, saveFeedback } from "../../store/appointment";
import { toast } from "react-toastify";
import AlertSuccess from "../common/alertSuccess";
import AlertError from "../common/alertError";

class FeedbackForm extends Form {
  state = {
    data: {
      ymmoment: "",
      feedback: "",
      is_publish_allowed: false,
    },
    errors: {},
    showPreview: false,
  };

  schema = {
    ymmoment: Joi.number()
      .required()
      .label("Moment")
      .error(() => {
        return { message: "Please select one option" };
      }),

    feedback: Joi.string()
      .required()
      .label("Feedback")
      .error(() => {
        return { message: "Feedback field is required" };
      }),

    is_publish_allowed: Joi.boolean(),
  };

  handleRadioChange = (e) => {
    const data = { ...this.state.data };
    data.ymmoment = Number(e.currentTarget.value);

    this.setState({ data });
  };

  resetForm = () => {
    this.setState({
      data: {
        ymmoment: "",
        feedback: "",
        is_publish_allowed: false,
      },
      errors: {},
      showPreview: false,
    });
  };

  doSubmit = () => {
    console.log("Submitted Data : ", this.state.data);

    this.props.saveFeedback(
      this.props.feedback_id,
      this.state.data,
      this.feedbackCallback,
    );
  };

  feedbackCallback = (res) => {
    if (res && res.status === 200) {
      toast(<AlertSuccess message="Feedback saved." />);
    } else {
      toast(<AlertError message="Something went wrong." />);
    }
    // this.resetForm();
    this.props.onHide()
  };

  componentDidMount() {
    this.props.loadFeedback(
      this.props.feedback_id
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.getFeedback &&
      this.props.getFeedback !==
        prevProps.getFeedback
    ) {
      this.setState({
        data: {
          ymmoment:
            this.props.getFeedback.ymmoment || "",
          feedback:
            this.props.getFeedback.feedback || "",
          is_publish_allowed:
            this.props.getFeedback
              .is_publish_allowed || false,
        },
      });
    }
  }

  render() {
    const { data, errors, showPreview } = this.state;
    const momentText = {
      1: "I feel better",
      2: "Didn't feel good",
      3: "Can't say",
    };

    return (
      <Modal
        {...this.props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal-header">
          <h3>Feedback</h3>
          <button
            type="button"
            className="close mt-2"
            data-dismiss="modal"
            onClick={this.props.onHide}
          >
            <img src={closeBtn} alt="close popup" />
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={this.handleSubmit} autoComplete="off">
            {/* Radio Buttons */}
            <div className="form-group">
              <label className="font-weight-bold">How are you feeling?</label>

              <div className="mt-2 d-flex align-items-center">
                <div className="form-check mr-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="feelbetter"
                    name="ymmoment"
                    value={1}
                    checked={data.ymmoment === 1}
                    onChange={this.handleRadioChange}
                  />

                  <label className="form-check-label" htmlFor="feelbetter">
                    I feel better
                  </label>
                </div>

                <div className="form-check mr-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="notgood"
                    name="ymmoment"
                    value={2}
                    checked={data.ymmoment === 2}
                    onChange={this.handleRadioChange}
                  />

                  <label className="form-check-label" htmlFor="notgood">
                    Didn't feel good
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="cantsay"
                    name="ymmoment"
                    value={3}
                    checked={data.ymmoment === 3}
                    onChange={this.handleRadioChange}
                  />

                  <label className="form-check-label" htmlFor="cantsay">
                    Can't say
                  </label>
                </div>
              </div>
            </div>

            {this.renderTextarea("feedback", "Add Feedback")}
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="is_publish_allowed"
                checked={data.is_publish_allowed}
                onChange={(e) => {
                  const dataState = {
                    ...data,
                  };
                  dataState.is_publish_allowed = e.target.checked;
                  this.setState({
                    data: dataState,
                  });
                }}
              />

              <label className="form-check-label" htmlFor="is_publish_allowed">
                Allow Doctor to publish this feedback on doctor's profile
              </label>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() =>
                  this.setState({
                    showPreview: !showPreview,
                  })
                }
              >
                {showPreview ? "Hide Preview" : "Preview"}
              </button>

              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>

            {showPreview && (
              <div className="card mt-4 p-3">
                <h5 className="mb-3">Preview</h5>

                <p>
                  <strong>YesMindy Moment :</strong> {momentText[data.ymmoment] || "-"}
                </p>

                <p>
                  <strong>Feedback :</strong> {data.feedback || "-"}
                </p>
              </div>
            )}
          </form>
        </div>
      </Modal>
    );
  }
}
const mapStateToProps = state => ({
  appointment: getAppointment(state),
  getFeedback: getAppointment(state).getFeedback,
})
const mapDispatchToProps = (dispatch) => ({
  saveFeedback: (id, payload, callback) =>
    dispatch(saveFeedback(id, payload, callback)),
  loadFeedback: (id, callback=null) =>
    dispatch(loadFeedback(id, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackForm);
